import { atom } from 'recoil'

export const departmentsState = atom({
    key: 'departmentsState',
    default: []
})

export const paymentListState = atom({
    key: 'paymentListState',
    default: []
})
export const usersState = atom({
    key: "admin.usersState",
    default: [],
  });